"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var componentStyle_1 = require("../utils/componentStyle");
var collection_1 = require("../utils/collection");
var replacePlaceholders_1 = require("../utils/replacePlaceholders");
var typeChecks_1 = require("../utils/typeChecks");
exports.DEFAULT_SKELETON_LOADER_TAG = 'div';
var SkeletonLoader = /** @class */ (function () {
    function SkeletonLoader(config, globalVariables) {
        if (globalVariables === void 0) { globalVariables = []; }
        this.config = config;
        this.globalVariables = globalVariables;
    }
    SkeletonLoader.prototype.render = function (targetElement) {
        if (targetElement) {
            this.renderElement(targetElement);
            this.renderStyle();
        }
    };
    SkeletonLoader.prototype.renderElement = function (targetElement) {
        var element = this.getElement();
        targetElement.appendChild(element);
    };
    SkeletonLoader.prototype.renderStyle = function () {
        var css = this.getSkeletonCss(true);
        if (css) {
            var styleElement = document.createElement('style');
            styleElement.innerHTML = css;
            document.head.appendChild(styleElement);
        }
    };
    Object.defineProperty(SkeletonLoader.prototype, "elementId", {
        get: function () {
            return "ksys-skeleton-" + this.config.id + "-" + this.configurationKey + "-" + this.styleKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SkeletonLoader.prototype, "configurationKey", {
        get: function () {
            return this.config.configurationKey || 'default';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SkeletonLoader.prototype, "styleKey", {
        get: function () {
            return this.config.styleKey || 'default';
        },
        enumerable: true,
        configurable: true
    });
    SkeletonLoader.prototype.getElement = function () {
        var _a = this.config.tag, tag = _a === void 0 ? exports.DEFAULT_SKELETON_LOADER_TAG : _a;
        var element = document.createElement(tag);
        element.id = this.elementId;
        return element;
    };
    SkeletonLoader.prototype.getValue = function (keyOrValue, variablesByKey) {
        return replacePlaceholders_1.replacePlaceholders(variablesByKey, keyOrValue);
    };
    SkeletonLoader.prototype.getSkeletonCss = function (wrapCssWithId) {
        if (wrapCssWithId === void 0) { wrapCssWithId = false; }
        var _a = this.config.breakpoints, breakpoints = _a === void 0 ? [] : _a;
        var response = [];
        for (var _i = 0, breakpoints_1 = breakpoints; _i < breakpoints_1.length; _i++) {
            var breakpoint = breakpoints_1[_i];
            var maxWidthInPixels = breakpoint.maxWidthInPixels, minWidthInPixels = breakpoint.minWidthInPixels;
            var css = this.getSkeletonInnerCss(breakpoint);
            var innerCss = [css];
            if (wrapCssWithId) {
                innerCss.unshift("#" + this.elementId + " {");
                innerCss.push('}');
            }
            if (!typeChecks_1.isNullOrUndefined(maxWidthInPixels) || !typeChecks_1.isNullOrUndefined(minWidthInPixels)) {
                var key = !typeChecks_1.isNullOrUndefined(maxWidthInPixels) ? 'max' : (!typeChecks_1.isNullOrUndefined(minWidthInPixels) ? 'min' : null);
                if (key) {
                    var value = !typeChecks_1.isNullOrUndefined(maxWidthInPixels) ? maxWidthInPixels : minWidthInPixels;
                    var defaultMedia = ['print', 'screen'];
                    var media = defaultMedia;
                    response.push("@media " + media.join(', ') + " and (" + key + "-width: " + value + "px) {");
                    response.push.apply(response, innerCss);
                    response.push("}");
                }
            }
            else {
                response.push.apply(response, innerCss);
            }
        }
        return response.join('\n');
    };
    SkeletonLoader.prototype.getSkeletonInnerCss = function (breakpoint) {
        var image = [];
        var position = [];
        var size = [];
        var _a = breakpoint.children, children = _a === void 0 ? [] : _a, _b = breakpoint.variables, variables = _b === void 0 ? [] : _b, style = breakpoint.style;
        var variablesByKey = collection_1.pivotCollection(__spreadArrays(this.globalVariables, variables), function (variable) { return variable.key; }, function (variable) { return variable.value; });
        for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
            var child = children_1[_i];
            var fill = child.fill, x = child.x, y = child.y, width = child.width, height = child.height;
            image.push("linear-gradient(" + this.getValue(fill, variablesByKey) + " " + this.getValue(height, variablesByKey) + ", transparent 0)");
            position.push(this.getValue(x, variablesByKey) + " " + this.getValue(y, variablesByKey));
            size.push(this.getValue(width, variablesByKey) + " " + this.getValue(height, variablesByKey));
        }
        var css = "\n\t" + (style ? componentStyle_1.getCss(style) : '') + "\n\tbackground-repeat: no-repeat;\n\tbackground-image: " + image.join(',') + ";\n\tbackground-position: " + position.join(',') + ";\n\tbackground-size: " + size.join(',') + ";\n\t\t\t";
        return css;
    };
    return SkeletonLoader;
}());
exports.SkeletonLoader = SkeletonLoader;
//# sourceMappingURL=SkeletonLoader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/appsManager/SkeletonLoader.js
// module id = 841
// module chunks = 1